import { getBoxLabelRegex } from '../../services'
import { SHOW_REPLENISHMENT, SHOW_REPLENISHMENT_BOXES } from '../../navigation/constants'

// Same discriminator ListActiveReplenishments.js uses for its "receive"
// action: replenishments with a box-label pattern go through the B2B box
// flow, everything else through the piece flow.
export const resolveReceptionPath = async (replenishmentId, warehouseId) => {
  const boxLabelPatterns = await getBoxLabelRegex(replenishmentId)
  const route = boxLabelPatterns?.replenishment_box_label_pattern ? SHOW_REPLENISHMENT_BOXES : SHOW_REPLENISHMENT
  return route.replace(':id', String(replenishmentId)).replace(':warehouse_id', String(warehouseId))
}
